// Try the desktop/mobile app via its protocol handler; if the page never loses
// focus (app not installed), fall back to the web version.
export const openAppOrWeb = (appUrl: string, webUrl: string) => {
  let appOpened = false;
  const onBlur = () => {
    appOpened = true;
  };
  window.addEventListener("blur", onBlur, { once: true });

  window.location.href = appUrl;

  setTimeout(() => {
    window.removeEventListener("blur", onBlur);
    if (!appOpened && document.visibilityState === "visible") {
      window.open(webUrl, "_blank", "noopener,noreferrer");
    }
  }, 1500);
};
